import request from '@/utils/axios';

// 获取微信分享
export const getWeXinSignature = (u: string) => {
    return request.get(`/backend/article/wechatShare?url=${u}`);
};